module.exports = __webpack_public_path__ + "media/images/vp/icon.notifications.black-9e9ed8493d8fb4cc2ea12760a79f6536.svg";